<template>
  <a-drawer
    v-bind="bindAttrs"
    @update:visible="emits('update:visible', false)"
  >
    <template #title>
      <div class="flex justify-between">
        <div>
          <div class="flex items-center mb-1">
            <div class="text-[20px]">
              {{ props.title }}
            </div>
            <div
              v-if="statusTip"
              style="color: #FFFFFF;"
              class="ml-3 text-[12px] px-[6px] rounded-[2px]"
              :class="statusTip?.textClass"
              :style="{backgroundColor:statusTip?.bgColor? statusTip?.bgColor:'#ccc'}"
            >
              {{ statusTip.text }}
            </div>
          </div>
          <div
            v-if="slugTip"
            class="text-[10px] font-light text-gray-500 font-semibold"
            :class="slugTip.textClass"
          >
            {{ slugTip.text }}
          </div>
          <div
            v-if="props.slug"
            class="text-[16px] font-light text-gray-500 font-semibold"
          >
            {{ props.slug }}
          </div>
        </div>
        <div class="flex items-center text-gray-500">
          <a-tooltip
            v-if="props.reloadable && !props.loading"
            title="刷新"
            class="mx-1"
          >
            <reload-outlined @click="handleReload" />
          </a-tooltip>
          <a-spin v-if="props.loading">
            <template #indicator>
              <loading-outlined :spin="true" />
            </template>
          </a-spin>
          <a-tooltip
            v-if="props.showClose"
            title="关闭"
            class="mx-1"
          >
            <close-outlined @click="emits('update:visible', false)" />
          </a-tooltip>
        </div>
      </div>
    </template>
    <div :style="{ padding: `${bodyPadding}px` }">
      <slot />
    </div>
    <div
      v-if="props.showFooter"
      :style="footerStyle"
      class="flex items-center justify-end px-4"
    >
      <a-space>
        <slot name="prependFooter" />
        <a-button
          v-if="props.showCancel"
          @click="handleCancel"
        >
          {{ props.cancelText }}
        </a-button>
        <slot name="centerFooter" />
        <a-button
          v-if="props.showConfirm"
          type="primary"
          @click="handleConfirm"
        >
          {{ props.confirmText }}
        </a-button>
        <slot name="appendFooter" />
        <div v-if="props.bottomActions?.length">
          <div
            v-for="btn in props.bottomActions"
            :key="btn.label"
          >
            <a-popconfirm
              v-if="btn.confirm && btn.isShow"
              :title="btn.confirm"
              @confirm="btn.click"
            >
              <a-button type="primary">
                {{ btn.label }}
              </a-button>
            </a-popconfirm>
            <a-button
              v-if="!btn.confirm && btn.isShow"
              type="primary"
              @click="btn.click"
            >
              {{ btn.label }}
            </a-button>
          </div>
        </div>
        <div
          v-if="props.bottomBtns?.length"
          class="flex"
        >
          <div
            v-for="btn in props.bottomBtns"
            :key="btn.label"
            style="margin: 0 10px;"
          >
            <a-button
              v-if="getBottomBtnShow(btn)"
              :type="btn.type || 'primary'"
              @click="btn.click"
            >
              {{ btn.label }}
            </a-button>
          </div>
        </div>
      </a-space>
    </div>
  </a-drawer>
</template>

<script lang="ts" setup>
import { computed, CSSProperties, nextTick, ref, unref, watch } from 'vue'
import { CloseOutlined, ReloadOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { basicDrawerProps, BotBtn } from './props'
import { omit, isFunction } from 'lodash-es'
import { getHtmlElementHeight } from '@/utils/dom'
import { useWindowSizeFn } from '@/hooks/window-size-fn'
import { useSystemStore } from '../../store/modules/system'

const bodyPadding = 20
const footerHeight = 50
const systemStore = useSystemStore()
const props = defineProps(basicDrawerProps)
const emits = defineEmits(['confirm', 'reload', 'update:visible', 'cancel'])

const bodyHeight = ref(200)

const getBottomBtnShow = (btn: BotBtn): boolean => {
  if (isFunction(btn.isShow)) {
    return btn.isShow()
  }
  return Boolean(btn.isShow) || btn.isShow === undefined
}

const bodyStyle = computed((): CSSProperties => ({
  padding: '0px',
  maxHeight: `${unref(bodyHeight)}px`,
  height: `${unref(bodyHeight)}px`,
  overflow: 'auto',
}))
const bindAttrs = computed(() => {
  let attrs = {
    zIndex: 1000,
    closable: false,
    bodyStyle: unref(bodyStyle),
    ...omit(props, ['title']),
  }
  if (!systemStore.isPc) {
    console.log('ceshi', 'systemStore.isPc')

    attrs.width = '90%'
  }
  return attrs
})


const footerStyle = computed((): CSSProperties => ({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: `${footerHeight}px`,
  borderTop: '1px solid #e8e8e8',
}))

watch(() => [props.visible, props.showFooter], setBodyHeight, { immediate: true })
useWindowSizeFn(setBodyHeight)

async function setBodyHeight() {
  if (!props.visible) {
    return
  }

  await nextTick()
  const headerHeight = getHtmlElementHeight('.ant-drawer-header')

  const height = window.innerHeight - headerHeight - bodyPadding - (props.showFooter ? footerHeight : 0)
  bodyHeight.value = height
}

function handleConfirm(e: Event) {
  e.stopPropagation()
  emits('confirm')
}

function handleReload(e: Event) {
  e.stopPropagation()
  emits('reload')
}
// @click="emits('update:visible', false)"
function handleCancel(e: Event) {
  props.autoCancelVisible && emits('update:visible', false)
  emits('cancel')
}
</script>
